<template>
    <BaseDialog
        :showDialog="showPayableConfirmationDialog"
        maxDialogWidth="500"
        headline="lang_GENERIC_DIALOG_HEADLINE_PAYABLE_CONFIRMATION"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t('lang_GENERIC_DIALOG_TEXT_PAYABLE_CONFIRMATION') }}<br />
                        {{ $t('lang_GENERIC_DIALOG_ENTER_CONFIRMATION_STRING') }}
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container>
                <v-row>
                    <v-col>
                        <v-text-field 
                            v-model="userInput" 
                            :messages="$t(errorMessage)" 
                            depressed
                            @keydown.enter="checkUserInput()"
                            class="ml-0 mr-0"
                            :label='$t("lang_GENERIC_DIALOG_TEXT_PAYABLE")'
                            :alvqa="alvqa + '-textfield-payable-confirmation'"
                        ></v-text-field>
                    </v-col>
                    <v-col class="text-right" align-self="center">
                        <BaseButton 
                            @click="checkUserInput()"
                            label="lang_GENERAL_CONFIRM"
                            :alvqa="alvqa+'-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "PayableConfirmationDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    props: {
        context: {
            default: '',
            type: String
        },
        useContextSetinVuex: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            userInput: '',
            errorMessage: '',
            alvqa: "payable-confirmation-dialog",
            defaultContext: this.$store.getters.getPayableConfirmationDialogContext
        }
    },
    computed: {
        showPayableConfirmationDialog: {
            get() { return this.$store.getters.getShowPayableConfirmationDialog },
            set(showPayableConfirmationDialog) { this.$store.commit('setShowPayableConfirmationDialog', showPayableConfirmationDialog) }
        },
        contextSetInVuex: { 
            get() { return this.$store.getters.getPayableConfirmationDialogContext },
            set(context) { this.$store.commit('setPayableConfirmationDialogContext', context) }
        },
        addNewPublishingCompany: { 
            get() { return this.$store.getters.getAddNewPublishingCompany },
            set(context) { this.$store.commit('setAddNewPublishingCompany', context) }
        },
        addNewLabelCompany: { 
            get() { return this.$store.getters.getAddNewLabelCompany },
            set(context) { this.$store.commit('setAddNewLabelCompany', context) }
        }
    },
    methods: {        
        closeDialog() {
            this.showPayableConfirmationDialog = false
            this.userInput = ''
            this.errorMessage = ''
            this.contextSetInVuex = ''
        },
        checkUserInput() { 
           if(this.userInput.toLowerCase().trim() === this.$t("lang_GENERIC_DIALOG_TEXT_PAYABLE")){
                this.closeDialog()
                this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

                if(this.addNewPublishingCompany){
                    this.$store.commit('setShowAccountPublishingCompaniesEditingDialog', true) 
                    let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultAccountPublishingCompanies)) 
                    this.$store.commit('setAccountPublishingCompaniesEditingDialogDetails', defaultValues)
                    this.addNewPublishingCompany = false
                }else if(this.addNewLabelCompany){
                    let companyType = this.$store.getters.getSelectedOverAllCompany.context
                    // only releases or freetext for Shipping documents (not like Invoices)
                    let searchType  = companyType == 2 ? "label/releases" : "publishing/releases"
                    this.$store.commit('setShippingShippingRowsTitleSearch', searchType)
                    this.$store.commit('setShippingShippingRowsIsNewSearch', true) // adding a new row
                    this.$store.commit('setShippingShippingRowsTitleOptions', [])
                    this.$store.commit('setShowAccountLabelCompaniesEditingDialog', true)
                    this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))
                    let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultShippingShippingRows)) 
                    this.$store.commit('setShippingShippingRowsEditingDialogDetails', defaultValues)
                    this.addNewLabelCompany = false
                }
            } 
            else this.errorMessage = 'lang_GENERIC_DIALOG_PAYABLE_CONFIRMATION_WRITE_STRING'
        }
    }
}
</script>